import { PROFILE_ROUTE_NAMES } from '../../../../../constants/route'

export function getViewingProfileTabUrl({ tab, viewingId }) {
  return PROFILE_ROUTE_NAMES.rentalPortalViewingProfile({
    additionalParams: `/${tab}`,
    id: viewingId,
  })
}
